<template>
  <div class="pack-empty-v4">
    <div class="pack-empty-v4__header">
      <div
        class="pack-empty-v4__meal"
      >
        <slot name="meal" />
      </div>
    </div>
    <div class="pack-empty-v4__content">
      <div
        class="pack-empty-v4__text"
      >
        <slot name="text" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.pack-empty-v4 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: map-get($colors, 'black');
  background: map-get($colors, 'white');
  padding: .20rem;
  height: 100%;
  width: 2.48rem;
  border-radius: .16rem;
  font-size: .16rem;
  &__header {
    position: absolute;
    margin-bottom: .18rem;
    width: 100%;
    display: flex;
    justify-content: center;
    @include typography('b3', 'medium');
  }
  &__meal {
    @include typography('b3', 'bold');
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: map-get($colors, 'secondary');
  }
  &__content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  &__text {
    font-weight: normal;
    @include typography('b2', 'medium');
    text-align: center;
    line-clamp: 2;
    overflow: hidden;
    max-width: 1.52rem;
    letter-spacing: 0.0015rem;
    color: map-get($colors, 'grey_60');
  }
}
</style>
